
export default function fb_goods(): any[] {
    return [ 
        {            
            "border_radius": 1,
            "gap": 30,
            style: {
                backgroundColor: "var(--force-plain-secondary-opacity-color)"
            },
            "card_fields": {
                title: {
                    style: {
                        lineHeight: 1.1,
                        fontSize: 20,
                        padding: "10px 20px"
                    }
                },
                "thumbnail": {
                    "height": 220,
                    "margin": 2,
                    "hover_size": 8,
                    "icon": "https://i.pinimg.com/736x/01/29/85/012985ea99c16d87137ffcdbb92046b0.jpg",
                    "style": {
                        "height": 220
                    }
                }, 
                "description": {
                    max_length: 500,
                    "style": {
                        "padding": "0 12px 12px 12px",
                        "fontSize": ".75em"
                    }
                },
                "content": {
                    max_length: 150,
                    "style": {
                        "padding": 12,
                        "fontSize": ".9em",
                    }
                },
                order: {
                    significant_zero: true,
                    card_fields_style: {
                        marginTop: -18,
                        transform: "translateX(calc(50% - 18px))"
                    },
                    style: {                        
                        width: 46,
                        height:46,
                        display: "flex",
                        justifyContent:"center",
                        alignItems: "center",
                        borderRadius: 46,
                        backgroundColor: "var(--force-plain-color)", 
                        color: "var(--force-contrast-opacity-color)",
                        fontSize: 16,
                    }
                },
                category_label: {
                    style: {
                        padding: 3
                    }
                },
                "divider": {},
                "links": {
                    "personalLinkType": "small",
                    "style": {
                        "padding": "12px 0"
                    }
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "1",
                            "title": "Известность"
                        },
                        {
                            "id": "2",
                            "title": "Порядочность"
                        },
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Чистоплотность"
                        }
                    ],
                    "min": 0,
                    "max": 5
                } 
            },
        },
    ]
}
 